var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kircWrapper", attrs: { id: "kirc" } },
    [
      _c("div", { staticClass: "particles" }),
      _vm._v(" "),
      _vm.kirc
        ? _c("div", { staticClass: "md-layout md-alignment-top-center" }, [
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-size-5 md-medium-size-10 md-small-size-100 md-xsmall-size-100"
              },
              [
                _vm.showResult
                  ? _c(
                      "md-button",
                      {
                        staticClass: "md-fab",
                        on: {
                          click: function($event) {
                            _vm.showResult = false
                          }
                        }
                      },
                      [_c("md-icon", [_vm._v("arrow_back")])],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-size-80 md-medium-size-95 md-small-size-95 md-xsmall-size-100"
              },
              [
                !_vm.showResult
                  ? _c(
                      "md-card",
                      { staticClass: "mainFormCard md-elevation-16" },
                      [
                        _c(
                          "md-card-header",
                          { staticClass: "header-wrapper" },
                          [
                            _c("div", { staticClass: "headlineWrapper" }, [
                              _c("div", { staticClass: "md-layout" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-layout-item md-size-50" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md-display-2 mainHeadline"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  KI-Readiness-Check\n                "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "md-layout-item md-size-50",
                                    attrs: { align: "right" }
                                  },
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass: "Secondary md-raised",
                                        attrs: { to: "/readinesscheck/res" }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "buttonText" },
                                          [_vm._v(" Ergebnis laden ")]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "progressbar-wrapper" },
                              [
                                _c("md-progress-bar", {
                                  staticStyle: { transform: "scaleY(6)" },
                                  attrs: {
                                    "md-mode": "determinate",
                                    "md-value": _vm.kircProgress
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "progressbar-content" }, [
                              _vm._v(_vm._s(_vm.kircProgress) + "%")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-card-content",
                          [
                            _c(
                              "md-steppers",
                              {
                                attrs: {
                                  id: "kircStepper",
                                  "md-vertical": "",
                                  "md-active-step": _vm.active
                                },
                                on: {
                                  "update:mdActiveStep": function($event) {
                                    _vm.active = $event
                                  },
                                  "update:md-active-step": function($event) {
                                    _vm.active = $event
                                  }
                                }
                              },
                              _vm._l(_vm.kirc, function(item, key) {
                                return _c(
                                  "div",
                                  { key: key },
                                  [
                                    _c(
                                      "md-step",
                                      {
                                        attrs: { "md-label": key, id: key },
                                        on: {
                                          click: function($event) {
                                            return _vm.scrollToTop()
                                          }
                                        }
                                      },
                                      [
                                        _vm._l(item, function(question, index) {
                                          return _c(
                                            "div",
                                            { key: question.name },
                                            [
                                              !question.optional
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "questionWrapper"
                                                    },
                                                    [
                                                      question.name ==
                                                      "Wie lautet die Postleitzahl Ihres Unternehmens?"
                                                        ? _c("div", [
                                                            _c(
                                                              "h3",
                                                              {
                                                                staticClass:
                                                                  "singleQuestion"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      question.newidx +
                                                                        ". Wo ist Ihr Unternehmen zu Hause?"
                                                                    ) +
                                                                    "\n                      "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("h5", [
                                                              _vm._v(
                                                                "Diese Angaben sind optional"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "md-layout md-gutter md-alignment-top-left"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "md-layout-item md-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "md-field",
                                                                      [
                                                                        _c(
                                                                          "md-select",
                                                                          {
                                                                            attrs: {
                                                                              name:
                                                                                "bundesland",
                                                                              id:
                                                                                "bundesland",
                                                                              placeholder:
                                                                                "Bundesland"
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm.bundesland,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.bundesland = $$v
                                                                              },
                                                                              expression:
                                                                                "bundesland"
                                                                            }
                                                                          },
                                                                          _vm._l(
                                                                            _vm.places,
                                                                            function(
                                                                              item,
                                                                              key
                                                                            ) {
                                                                              return _c(
                                                                                "md-option",
                                                                                {
                                                                                  key: key,
                                                                                  attrs: {
                                                                                    value: key
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      key
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            }
                                                                          ),
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "md-layout-item md-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100"
                                                                  },
                                                                  [
                                                                    _vm.bundesland
                                                                      ? _c(
                                                                          "md-field",
                                                                          [
                                                                            _c(
                                                                              "md-select",
                                                                              {
                                                                                attrs: {
                                                                                  name:
                                                                                    "landkreis",
                                                                                  id:
                                                                                    "landkreis",
                                                                                  placeholder:
                                                                                    "Landkreis"
                                                                                },
                                                                                model: {
                                                                                  value:
                                                                                    _vm
                                                                                      .kircinstance[
                                                                                      key
                                                                                    ][
                                                                                      index
                                                                                    ]
                                                                                      .answers[0]
                                                                                      .input,
                                                                                  callback: function(
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .kircinstance[
                                                                                        key
                                                                                      ][
                                                                                        index
                                                                                      ]
                                                                                        .answers[0],
                                                                                      "input",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                  expression:
                                                                                    "\n                                kircinstance[key][index].answers[0].input\n                              "
                                                                                }
                                                                              },
                                                                              _vm._l(
                                                                                _vm
                                                                                  .places[
                                                                                  _vm
                                                                                    .bundesland
                                                                                ]
                                                                                  .landkreis,
                                                                                function(
                                                                                  lk
                                                                                ) {
                                                                                  return _c(
                                                                                    "md-option",
                                                                                    {
                                                                                      key:
                                                                                        lk.name,
                                                                                      attrs: {
                                                                                        value:
                                                                                          lk.plz
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          lk.name
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                }
                                                                              ),
                                                                              1
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e()
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        : _c("div", [
                                                            _c(
                                                              "h3",
                                                              {
                                                                staticClass:
                                                                  "singleQuestion",
                                                                staticStyle: {
                                                                  display:
                                                                    "inline-flex"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle: {
                                                                      width:
                                                                        "auto"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        question.newidx +
                                                                          ". " +
                                                                          question.name
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "questionMarkIcon",
                                                                  attrs: {
                                                                    src: require("../../../assets/question-mark.svg"),
                                                                    alt:
                                                                      "question mark"
                                                                  }
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "tooltiptext"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Die Datenverfügbarkeit beschreibt, wie leicht und zuverlässig die benötigten Daten für die Entwicklung, das Training und den Betrieb von Künstlicher Intelligenz zugänglich und nutzbar sind."
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            question.type ==
                                                            "multiple"
                                                              ? _c("h5", [
                                                                  _vm._v(
                                                                    "\n                        Mehrfachauswahl möglich\n                      "
                                                                  )
                                                                ])
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "md-layout md-gutter md-alignment-top-left"
                                                              },
                                                              [
                                                                question.answers
                                                                  .length > 11
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "md-layout-item md-size-60 md-medium-size-50 md-small-size-100 md-xsmall-size-100 answerBoxes drop",
                                                                        attrs: {
                                                                          id:
                                                                            "largeDropdown"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-select",
                                                                          {
                                                                            attrs: {
                                                                              items:
                                                                                question.answers,
                                                                              "item-text":
                                                                                "text",
                                                                              "item-value":
                                                                                "text",
                                                                              label:
                                                                                "Antwort",
                                                                              "persistent-hint":
                                                                                "",
                                                                              "single-line":
                                                                                ""
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .kircinstance[
                                                                                  key
                                                                                ][
                                                                                  index
                                                                                ]
                                                                                  .answers[0]
                                                                                  .input,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm
                                                                                    .kircinstance[
                                                                                    key
                                                                                  ][
                                                                                    index
                                                                                  ]
                                                                                    .answers[0],
                                                                                  "input",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "\n                              kircinstance[key][index].answers[0].input\n                            "
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._l(
                                                                      question.answers,
                                                                      function(
                                                                        answer
                                                                      ) {
                                                                        return _c(
                                                                          "div",
                                                                          {
                                                                            key:
                                                                              answer.text,
                                                                            staticClass:
                                                                              "md-layout-item md-size-20 md-medium-size-20 md-small-size-100 md-xsmall-size-100 answerBoxes"
                                                                          },
                                                                          [
                                                                            (answer.name ==
                                                                              "keine Antwort möglich" ||
                                                                              answer.name ==
                                                                                "Keine der angegebenen Möglichkeiten.") &&
                                                                            question.type ==
                                                                              "multiple"
                                                                              ? _c(
                                                                                  "md-checkbox",
                                                                                  {
                                                                                    attrs: {
                                                                                      value: answer
                                                                                    },
                                                                                    on: {
                                                                                      change: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.deselect(
                                                                                          key,
                                                                                          index
                                                                                        )
                                                                                      }
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        _vm
                                                                                          .kircinstance[
                                                                                          key
                                                                                        ][
                                                                                          index
                                                                                        ]
                                                                                          .answers,
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .kircinstance[
                                                                                            key
                                                                                          ][
                                                                                            index
                                                                                          ],
                                                                                          "answers",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                      expression:
                                                                                        "kircinstance[key][index].answers"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        answer.name
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : answer.name !=
                                                                                  "Freitextantwort" &&
                                                                                question.type ==
                                                                                  "multiple"
                                                                              ? _c(
                                                                                  "md-checkbox",
                                                                                  {
                                                                                    attrs: {
                                                                                      value: answer
                                                                                    },
                                                                                    on: {
                                                                                      change: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.removeDeselect(
                                                                                          key,
                                                                                          index
                                                                                        )
                                                                                      }
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        _vm
                                                                                          .kircinstance[
                                                                                          key
                                                                                        ][
                                                                                          index
                                                                                        ]
                                                                                          .answers,
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .kircinstance[
                                                                                            key
                                                                                          ][
                                                                                            index
                                                                                          ],
                                                                                          "answers",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                      expression:
                                                                                        "kircinstance[key][index].answers"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        answer.name
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : answer.name !=
                                                                                  "Freitextantwort" &&
                                                                                question.type ==
                                                                                  null
                                                                              ? _c(
                                                                                  "md-checkbox",
                                                                                  {
                                                                                    attrs: {
                                                                                      value: answer
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        _vm
                                                                                          .kircinstance[
                                                                                          key
                                                                                        ][
                                                                                          index
                                                                                        ]
                                                                                          .answers[0],
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .kircinstance[
                                                                                            key
                                                                                          ][
                                                                                            index
                                                                                          ]
                                                                                            .answers,
                                                                                          0,
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                      expression:
                                                                                        "kircinstance[key][index].answers[0]"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        answer.text
                                                                                      ) +
                                                                                        "\n                          "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : (answer.name =
                                                                                  "Freitextantwort") &&
                                                                                question.type ==
                                                                                  null &&
                                                                                _vm
                                                                                  .kircinstance[
                                                                                  key
                                                                                ][
                                                                                  index
                                                                                ]
                                                                                  .answers[0] !=
                                                                                  null
                                                                              ? _vm._l(
                                                                                  _vm
                                                                                    .kircinstance[
                                                                                    key
                                                                                  ][
                                                                                    index
                                                                                  ]
                                                                                    .answers,
                                                                                  function(
                                                                                    answerInstance
                                                                                  ) {
                                                                                    return _c(
                                                                                      "md-field",
                                                                                      {
                                                                                        directives: [
                                                                                          {
                                                                                            name:
                                                                                              "show",
                                                                                            rawName:
                                                                                              "v-show",
                                                                                            value:
                                                                                              answerInstance.name ==
                                                                                              "Sonstige*",
                                                                                            expression:
                                                                                              "\n                                answerInstance.name ==\n                                'Sonstige*'\n                              "
                                                                                          }
                                                                                        ],
                                                                                        key:
                                                                                          answerInstance.hash
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "label",
                                                                                          [
                                                                                            _vm._v(
                                                                                              "Antwort"
                                                                                            )
                                                                                          ]
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "md-input",
                                                                                          {
                                                                                            model: {
                                                                                              value:
                                                                                                _vm
                                                                                                  .kircinstance[
                                                                                                  key
                                                                                                ][
                                                                                                  index
                                                                                                ]
                                                                                                  .answers[0]
                                                                                                  .input,
                                                                                              callback: function(
                                                                                                $$v
                                                                                              ) {
                                                                                                _vm.$set(
                                                                                                  _vm
                                                                                                    .kircinstance[
                                                                                                    key
                                                                                                  ][
                                                                                                    index
                                                                                                  ]
                                                                                                    .answers[0],
                                                                                                  "input",
                                                                                                  $$v
                                                                                                )
                                                                                              },
                                                                                              expression:
                                                                                                "\n                                kircinstance[key][index].answers[0].input\n                              "
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  }
                                                                                )
                                                                              : _vm._e()
                                                                          ],
                                                                          2
                                                                        )
                                                                      }
                                                                    ),
                                                                _vm._v(" "),
                                                                question.followindices &&
                                                                question
                                                                  .followindices
                                                                  .length > 0 &&
                                                                _vm
                                                                  .kircinstance[
                                                                  key
                                                                ][index]
                                                                  .answers[0] &&
                                                                _vm
                                                                  .kircinstance[
                                                                  key
                                                                ][index]
                                                                  .answers[0]
                                                                  .causesfollowup
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                                                      },
                                                                      _vm._l(
                                                                        question.followindices,
                                                                        function(
                                                                          idx
                                                                        ) {
                                                                          return _c(
                                                                            "div",
                                                                            {
                                                                              key: idx,
                                                                              staticStyle: {
                                                                                "padding-left":
                                                                                  "100px",
                                                                                "padding-top":
                                                                                  "30px"
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "h3",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      item[
                                                                                        idx -
                                                                                          1
                                                                                      ]
                                                                                        .name
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              item[
                                                                                idx -
                                                                                  1
                                                                              ]
                                                                                .type ==
                                                                              "multiple"
                                                                                ? _c(
                                                                                    "h6",
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                              Mehrfachauswahl möglich\n                            "
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "md-layout md-gutter md-alignment-top-left"
                                                                                },
                                                                                _vm._l(
                                                                                  item[
                                                                                    idx -
                                                                                      1
                                                                                  ]
                                                                                    .answers,
                                                                                  function(
                                                                                    followanswer
                                                                                  ) {
                                                                                    return _c(
                                                                                      "div",
                                                                                      {
                                                                                        key:
                                                                                          followanswer.text,
                                                                                        staticClass:
                                                                                          "md-layout-item md-size-20 md-medium-size-20 md-small-size-100 md-xsmall-size-100"
                                                                                      },
                                                                                      [
                                                                                        item[
                                                                                          idx -
                                                                                            1
                                                                                        ]
                                                                                          .type ==
                                                                                        "multiple"
                                                                                          ? _c(
                                                                                              "md-checkbox",
                                                                                              {
                                                                                                attrs: {
                                                                                                  value: followanswer
                                                                                                },
                                                                                                model: {
                                                                                                  value:
                                                                                                    _vm
                                                                                                      .kircinstance[
                                                                                                      key
                                                                                                    ][
                                                                                                      idx -
                                                                                                        1
                                                                                                    ]
                                                                                                      .answers,
                                                                                                  callback: function(
                                                                                                    $$v
                                                                                                  ) {
                                                                                                    _vm.$set(
                                                                                                      _vm
                                                                                                        .kircinstance[
                                                                                                        key
                                                                                                      ][
                                                                                                        idx -
                                                                                                          1
                                                                                                      ],
                                                                                                      "answers",
                                                                                                      $$v
                                                                                                    )
                                                                                                  },
                                                                                                  expression:
                                                                                                    "kircinstance[key][idx - 1].answers"
                                                                                                }
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    followanswer.text
                                                                                                  )
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          : _c(
                                                                                              "md-checkbox",
                                                                                              {
                                                                                                attrs: {
                                                                                                  value: followanswer
                                                                                                },
                                                                                                model: {
                                                                                                  value:
                                                                                                    _vm
                                                                                                      .kircinstance[
                                                                                                      key
                                                                                                    ][
                                                                                                      idx -
                                                                                                        1
                                                                                                    ]
                                                                                                      .answers[0],
                                                                                                  callback: function(
                                                                                                    $$v
                                                                                                  ) {
                                                                                                    _vm.$set(
                                                                                                      _vm
                                                                                                        .kircinstance[
                                                                                                        key
                                                                                                      ][
                                                                                                        idx -
                                                                                                          1
                                                                                                      ]
                                                                                                        .answers,
                                                                                                      0,
                                                                                                      $$v
                                                                                                    )
                                                                                                  },
                                                                                                  expression:
                                                                                                    "\n                                    kircinstance[key][idx - 1].answers[0]\n                                  "
                                                                                                }
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    followanswer.text
                                                                                                  ) +
                                                                                                    "\n                                "
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  }
                                                                                ),
                                                                                0
                                                                              )
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      0
                                                                    )
                                                                  : question.followup &&
                                                                    _vm
                                                                      .kircinstance[
                                                                      key
                                                                    ][index]
                                                                      .answers[0] &&
                                                                    _vm
                                                                      .kircinstance[
                                                                      key
                                                                    ][index]
                                                                      .answers[0]
                                                                      .causesfollowup &&
                                                                    question.followup !==
                                                                      "matrix"
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticStyle: {
                                                                              "padding-left":
                                                                                "100px"
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "h3",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    question.followup
                                                                                  )
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "md-field",
                                                                              [
                                                                                _c(
                                                                                  "label",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Antwort"
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                question.followup.includes(
                                                                                  "Prozent"
                                                                                )
                                                                                  ? _c(
                                                                                      "md-input",
                                                                                      {
                                                                                        attrs: {
                                                                                          type:
                                                                                            "number"
                                                                                        },
                                                                                        model: {
                                                                                          value:
                                                                                            _vm
                                                                                              .kircinstance[
                                                                                              key
                                                                                            ][
                                                                                              index
                                                                                            ]
                                                                                              .answers[0]
                                                                                              .followup,
                                                                                          callback: function(
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              _vm
                                                                                                .kircinstance[
                                                                                                key
                                                                                              ][
                                                                                                index
                                                                                              ]
                                                                                                .answers[0],
                                                                                              "followup",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                          expression:
                                                                                            "\n                                  kircinstance[key][index].answers[0].followup\n                                "
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  : _c(
                                                                                      "md-input",
                                                                                      {
                                                                                        model: {
                                                                                          value:
                                                                                            _vm
                                                                                              .kircinstance[
                                                                                              key
                                                                                            ][
                                                                                              index
                                                                                            ]
                                                                                              .answers[0]
                                                                                              .followup,
                                                                                          callback: function(
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              _vm
                                                                                                .kircinstance[
                                                                                                key
                                                                                              ][
                                                                                                index
                                                                                              ]
                                                                                                .answers[0],
                                                                                              "followup",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                          expression:
                                                                                            "\n                                  kircinstance[key][index].answers[0].followup\n                                "
                                                                                        }
                                                                                      }
                                                                                    )
                                                                              ],
                                                                              1
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                question.followup &&
                                                                _vm
                                                                  .kircinstance[
                                                                  key
                                                                ][index]
                                                                  .answers[0] &&
                                                                _vm
                                                                  .kircinstance[
                                                                  key
                                                                ][index]
                                                                  .answers[0]
                                                                  .causesfollowup &&
                                                                question.followup ===
                                                                  "matrix"
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticStyle: {
                                                                              "padding-left":
                                                                                "100px"
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "h3",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .matrixquestion
                                                                                      .question
                                                                                  )
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "md-layout md-gutter md-alignment-top-left"
                                                                              },
                                                                              _vm._l(
                                                                                _vm
                                                                                  .matrixquestion
                                                                                  .answers,
                                                                                function(
                                                                                  matrixanswer
                                                                                ) {
                                                                                  return _c(
                                                                                    "div",
                                                                                    {
                                                                                      key:
                                                                                        matrixanswer.text,
                                                                                      staticClass:
                                                                                        "md-layout-item md-size-20 md-medium-size-20 md-small-size-100 md-xsmall-size-100"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "md-checkbox",
                                                                                        {
                                                                                          attrs: {
                                                                                            value: matrixanswer
                                                                                          },
                                                                                          model: {
                                                                                            value:
                                                                                              _vm
                                                                                                .kircinstance[
                                                                                                key
                                                                                              ][
                                                                                                index
                                                                                              ]
                                                                                                .answers[1],
                                                                                            callback: function(
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                _vm
                                                                                                  .kircinstance[
                                                                                                  key
                                                                                                ][
                                                                                                  index
                                                                                                ]
                                                                                                  .answers,
                                                                                                1,
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                            expression:
                                                                                              "\n                                    kircinstance[key][index].answers[1]\n                                  "
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              matrixanswer.text
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                }
                                                                              ),
                                                                              0
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              2
                                                            )
                                                          ])
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        }),
                                        _vm._v(" "),
                                        key == "Abschließende Fragen"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "confirmationWrapper"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "questionWrapper"
                                                  },
                                                  [
                                                    _c(
                                                      "h3",
                                                      {
                                                        staticClass:
                                                          "singleQuestion"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            Bitte geben Sie Ihre E-Mail-Adresse an, wenn Sie die Ergebnisse des KI-Readiness-Checks zusätzlich per Mail/als PDF erhalten möchten.\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("h5", [
                                                      _vm._v(
                                                        "Diese Angaben sind optional"
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "md-field",
                                                      {
                                                        class: _vm.emailValid,
                                                        staticStyle: {
                                                          "max-width": "300px"
                                                        }
                                                      },
                                                      [
                                                        _c("label", [
                                                          _vm._v(
                                                            "Kontakt E-Mail"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("md-input", {
                                                          model: {
                                                            value: _vm.email,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.email = $$v
                                                            },
                                                            expression: "email"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "md-error"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "E-Mail Addresse is nicht gültig"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "md-button",
                                                      {
                                                        staticClass:
                                                          "md-accent md-raised nextBtn",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.setDone(
                                                              key
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "KIRC Abschließen"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "md-switch",
                                                  {
                                                    model: {
                                                      value: _vm.forTesting,
                                                      callback: function($$v) {
                                                        _vm.forTesting = $$v
                                                      },
                                                      expression: "forTesting"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Dies ist ein Testlauf"
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "confirmationWrapper"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "md-button",
                                                      {
                                                        staticClass:
                                                          "md-accent md-raised nextBtn",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.setDone(
                                                              key
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("Weiter")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _vm.error &&
                            _vm.error !=
                              "Sie haben die folgenden Fragen noch nicht beantwortet:<ul></ul>"
                              ? _c("div", {
                                  staticClass: "missedQuestions",
                                  domProps: { innerHTML: _vm._s(_vm.error) }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showProgress
                              ? _c("md-progress-bar", {
                                  staticClass: "md-accent",
                                  attrs: { "md-mode": "indeterminate" }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showResult
                  ? _c(
                      "md-card",
                      [
                        _c("md-card-content", [
                          _c(
                            "div",
                            {
                              staticClass: "md-layout",
                              class: "md-alignment-top-left"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-size-40 md-medium-size-50 md-small-size-100 md-xsmall-size-100",
                                  class: "md-alignment-top-left"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "stickyHeading__Wrapper" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "md-display-1 kiReadinessLevel__H1"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Ergebnisse\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("md-divider")
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "md-layout",
                              class: "md-alignment-top-center"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-size-40 md-medium-size-50 md-small-size-100 md-xsmall-size-100",
                                  class: "md-alignment-top-center"
                                },
                                [
                                  _c(
                                    "md-card",
                                    {
                                      staticClass: "CustomCard md-elevation-4"
                                    },
                                    [
                                      _c("md-card-content", [
                                        _c(
                                          "div",
                                          { staticClass: "stars-wrapper" },
                                          [
                                            Math.ceil(_vm.finalscore / 68) >= 1
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            Math.ceil(_vm.finalscore / 68) >= 2
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            Math.ceil(_vm.finalscore / 68) >= 3
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            Math.ceil(_vm.finalscore / 68) >= 4
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            Math.ceil(_vm.finalscore / 68) >= 5
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            Math.ceil(_vm.finalscore / 68) < 2
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star_gray.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            Math.ceil(_vm.finalscore / 68) < 3
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star_gray.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            Math.ceil(_vm.finalscore / 68) < 4
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star_gray.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            Math.ceil(_vm.finalscore / 68) < 5
                                              ? _c("img", {
                                                  staticClass: "star",
                                                  attrs: {
                                                    src: require("../../../assets/star_gray.svg"),
                                                    alt: "Star",
                                                    width: "60",
                                                    height: "60"
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "progress-wrapper" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "finalScoreWrapper"
                                              },
                                              [
                                                _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "levelSubheading"
                                                  },
                                                  [_vm._v("Level")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "h1",
                                                  {
                                                    staticClass: "mb-2",
                                                    attrs: { id: "finalScore" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          Math.ceil(
                                                            _vm.finalscore / 68
                                                          ) + "/5"
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                Math.ceil(
                                                  _vm.finalscore / 68
                                                ) === 1
                                                  ? _c(
                                                      "h1",
                                                      {
                                                        attrs: {
                                                          slot:
                                                            "textCard__Headline"
                                                        },
                                                        slot:
                                                          "textCard__Headline"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.level1.name
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                Math.ceil(
                                                  _vm.finalscore / 68
                                                ) === 2
                                                  ? _c(
                                                      "h1",
                                                      {
                                                        attrs: {
                                                          slot:
                                                            "textCard__Headline"
                                                        },
                                                        slot:
                                                          "textCard__Headline"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.level2.name
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                Math.ceil(
                                                  _vm.finalscore / 68
                                                ) === 3
                                                  ? _c(
                                                      "h1",
                                                      {
                                                        attrs: {
                                                          slot:
                                                            "textCard__Headline"
                                                        },
                                                        slot:
                                                          "textCard__Headline"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.level3.name
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                Math.ceil(
                                                  _vm.finalscore / 68
                                                ) === 4
                                                  ? _c(
                                                      "h1",
                                                      {
                                                        attrs: {
                                                          slot:
                                                            "textCard__Headline"
                                                        },
                                                        slot:
                                                          "textCard__Headline"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.level4.name
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                Math.ceil(
                                                  _vm.finalscore / 68
                                                ) === 5
                                                  ? _c(
                                                      "h1",
                                                      {
                                                        attrs: {
                                                          slot:
                                                            "textCard__Headline"
                                                        },
                                                        slot:
                                                          "textCard__Headline"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.level5.name
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-size-60 md-medium-size-50 md-small-size-100 md-xsmall-size-100",
                                  class: "md-alignment-top-center"
                                },
                                [
                                  _c("TextCard", [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "textCard__Icon" },
                                        slot: "textCard__Icon"
                                      },
                                      [_vm._v("compare_arrows")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "textCard__Headline" },
                                        slot: "textCard__Headline"
                                      },
                                      [
                                        _vm._v(
                                          "Vergleich zu anderen Unternehmen"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "textCard__Text" },
                                        slot: "textCard__Text"
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticStyle: { display: "block" } },
                                          [
                                            _vm._v(
                                              "\n                    Andere Unternehmen Ihrer Branche haben durchschnittlich"
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              " einen KI-Readiness-Level "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-weight": "bold"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.levelIndustry)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "stars-wrapper" },
                                              [
                                                _vm.levelIndustry >= 1
                                                  ? _c("img", {
                                                      staticClass: "star-small",
                                                      attrs: {
                                                        src: require("../../../assets/star.svg"),
                                                        alt: "Star",
                                                        width: "15",
                                                        height: "15"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.levelIndustry >= 2
                                                  ? _c("img", {
                                                      staticClass: "star-small",
                                                      attrs: {
                                                        src: require("../../../assets/star.svg"),
                                                        alt: "Star",
                                                        width: "15",
                                                        height: "15"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.levelIndustry >= 3
                                                  ? _c("img", {
                                                      staticClass: "star-small",
                                                      attrs: {
                                                        src: require("../../../assets/star.svg"),
                                                        alt: "Star",
                                                        width: "15",
                                                        height: "15"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.levelIndustry >= 4
                                                  ? _c("img", {
                                                      staticClass: "star-small",
                                                      attrs: {
                                                        src: require("../../../assets/star.svg"),
                                                        alt: "Star",
                                                        width: "15",
                                                        height: "15"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.levelIndustry >= 5
                                                  ? _c("img", {
                                                      staticClass: "star-small",
                                                      attrs: {
                                                        src: require("../../../assets/star.svg"),
                                                        alt: "Star",
                                                        width: "15",
                                                        height: "15"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.levelIndustry < 2
                                                  ? _c("img", {
                                                      staticClass: "star-small",
                                                      attrs: {
                                                        src: require("../../../assets/star_gray.svg"),
                                                        alt: "Star",
                                                        width: "15",
                                                        height: "15"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.levelIndustry < 3
                                                  ? _c("img", {
                                                      staticClass: "star-small",
                                                      attrs: {
                                                        src: require("../../../assets/star_gray.svg"),
                                                        alt: "Star",
                                                        width: "15",
                                                        height: "15"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.levelIndustry < 4
                                                  ? _c("img", {
                                                      staticClass: "star-small",
                                                      attrs: {
                                                        src: require("../../../assets/star_gray.svg"),
                                                        alt: "Star",
                                                        width: "15",
                                                        height: "15"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.levelIndustry < 5
                                                  ? _c("img", {
                                                      staticClass: "star-small",
                                                      attrs: {
                                                        src: require("../../../assets/star_gray.svg"),
                                                        alt: "Star",
                                                        width: "15",
                                                        height: "15"
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(
                                              "\n                       erreicht.\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticStyle: { display: "block" } },
                                          [
                                            _vm._v(
                                              "\n                    Andere Unternehmen Ihrer Größe haben durchschnittlich"
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              " einen KI-Readiness-Level "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-weight": "bold"
                                                }
                                              },
                                              [_vm._v(_vm._s(_vm.levelSize))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "stars-wrapper" },
                                              [
                                                _vm.levelSize >= 1
                                                  ? _c("img", {
                                                      staticClass: "star-small",
                                                      attrs: {
                                                        src: require("../../../assets/star.svg"),
                                                        alt: "Star",
                                                        width: "15",
                                                        height: "15"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.levelSize >= 2
                                                  ? _c("img", {
                                                      staticClass: "star-small",
                                                      attrs: {
                                                        src: require("../../../assets/star.svg"),
                                                        alt: "Star",
                                                        width: "15",
                                                        height: "15"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.levelSize >= 3
                                                  ? _c("img", {
                                                      staticClass: "star-small",
                                                      attrs: {
                                                        src: require("../../../assets/star.svg"),
                                                        alt: "Star",
                                                        width: "15",
                                                        height: "15"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.levelSize >= 4
                                                  ? _c("img", {
                                                      staticClass: "star-small",
                                                      attrs: {
                                                        src: require("../../../assets/star.svg"),
                                                        alt: "Star",
                                                        width: "15",
                                                        height: "15"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.levelSize >= 5
                                                  ? _c("img", {
                                                      staticClass: "star-small",
                                                      attrs: {
                                                        src: require("../../../assets/star.svg"),
                                                        alt: "Star",
                                                        width: "15",
                                                        height: "15"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.levelSize < 2
                                                  ? _c("img", {
                                                      staticClass: "star-small",
                                                      attrs: {
                                                        src: require("../../../assets/star_gray.svg"),
                                                        alt: "Star",
                                                        width: "15",
                                                        height: "15"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.levelSize < 3
                                                  ? _c("img", {
                                                      staticClass: "star-small",
                                                      attrs: {
                                                        src: require("../../../assets/star_gray.svg"),
                                                        alt: "Star",
                                                        width: "15",
                                                        height: "15"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.levelSize < 4
                                                  ? _c("img", {
                                                      staticClass: "star-small",
                                                      attrs: {
                                                        src: require("../../../assets/star_gray.svg"),
                                                        alt: "Star",
                                                        width: "15",
                                                        height: "15"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.levelSize < 5
                                                  ? _c("img", {
                                                      staticClass: "star-small",
                                                      attrs: {
                                                        src: require("../../../assets/star_gray.svg"),
                                                        alt: "Star",
                                                        width: "15",
                                                        height: "15"
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(
                                              "\n                    erreicht.\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-size": "small"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "Basiert auf Auswertung von " +
                                                _vm._s(
                                                  _vm.amountCompaniesComparison
                                                ) +
                                                " Unternehmen."
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "md-layout",
                              class: "md-alignment-top-center"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-size-80 md-medium-size-80 md-small-size-100 md-xsmall-size-100",
                                  class: "md-alignment-top-center"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "stickyHeading__Wrapper" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "md-display-1 kiReadinessLevel__H1"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "Empfehlungen nach Reifegrad"
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("md-divider")
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.rec, function(item, key) {
                                    return _c(
                                      "md-card",
                                      { key: key, staticClass: "TextCard" },
                                      [
                                        _c(
                                          "md-card-header",
                                          { staticClass: "TextCard__Wrapper" },
                                          [
                                            _c(
                                              "md-card-header-text",
                                              {
                                                staticClass: "TextCard__Header"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "IconBox" },
                                                  [
                                                    _c(
                                                      "md-icon",
                                                      {
                                                        staticClass:
                                                          "IconBox__Icon"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        home\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "md-title",
                                                    staticStyle: {
                                                      display: "flex"
                                                    }
                                                  },
                                                  [
                                                    _c("h5", [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(key) +
                                                          "\n                      "
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "stars-wrapper",
                                                        staticStyle: {
                                                          "margin-left": "15px"
                                                        }
                                                      },
                                                      [
                                                        _vm.reifeGradLevel[
                                                          key
                                                        ] >= 1
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.reifeGradLevel[
                                                          key
                                                        ] >= 2
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.reifeGradLevel[
                                                          key
                                                        ] >= 3
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.reifeGradLevel[
                                                          key
                                                        ] >= 4
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.reifeGradLevel[
                                                          key
                                                        ] >= 5
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.reifeGradLevel[
                                                          key
                                                        ] < 2
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star_gray.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.reifeGradLevel[
                                                          key
                                                        ] < 3
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star_gray.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.reifeGradLevel[
                                                          key
                                                        ] < 4
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star_gray.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.reifeGradLevel[
                                                          key
                                                        ] < 5
                                                          ? _c("img", {
                                                              staticClass:
                                                                "star-small",
                                                              attrs: {
                                                                src: require("../../../assets/star_gray.svg"),
                                                                alt: "Star",
                                                                width: "15",
                                                                height: "15"
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "md-card-content",
                                          { staticClass: "TextCard__Content" },
                                          _vm._l(_vm.rec[key], function(
                                            item,
                                            key
                                          ) {
                                            return _c(
                                              "div",
                                              { key: key },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "md-layout md-gutter md-alignment-center-center"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          visibility: "hidden"
                                                        }
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(item.level) +
                                                              "/5"
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "md-layout-item reifegrad"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(item.reife)
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(item.level) +
                                                            "/5"
                                                        )
                                                      ])
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "md-layout md-gutter md-alignment-top-center recommendation_container"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "md-layout-item recommendation"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "bold"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Statusbericht: "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.zustand
                                                              )
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "md-layout-item recommendation"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "bold"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Empfehlung: "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.empfehlung
                                                              )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("md-divider", {
                                                  staticStyle: {
                                                    "margin-top": "10px",
                                                    "margin-bottom": "10px"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          }),
                                          0
                                        )
                                      ],
                                      1
                                    )
                                  })
                                ],
                                2
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "md-card-actions",
                          { staticClass: "resultAction-Wrapper" },
                          [
                            !_vm.loggedIn
                              ? _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "md-raised text-align-left md-primary CTA CTA--newCheck",
                                    attrs: { to: "/readiness-welcome" }
                                  },
                                  [
                                    _c("span", { staticClass: "buttonText" }, [
                                      _vm._v("Neuer Check")
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.loggedIn
                              ? _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "md-raised md-primary CTA CTA--signup",
                                    attrs: {
                                      to: "/readinesscheck/" + _vm.resulttoken
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "buttonText" }, [
                                      _vm._v("Jetzt Anmelden")
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "md-layout-item md-size-5 md-medium-size-10 md-small-size-100 md-xsmall-size-100"
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "can-cancel": false,
          "is-full-page": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "md-layout-item md-size-5 md-medium-size-10 md-small-size-100 md-xsmall-size-100"
      }),
      _vm._v(" "),
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "can-cancel": false,
          "is-full-page": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-420ebc9d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-420ebc9d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/kirc/KIRC.vue
// module id = null
// module chunks = 